/**
 * Campaña "Vuelta a la rutina" (septiembre 2026).
 *
 * La fecha de fin vivía copiada en `Landing.jsx` y en `Waitlist.jsx`. Ahora que
 * la barra superior sale en TODAS las páginas hay un tercer sitio, y tres copias
 * de un `2026-09-30` es la forma más fácil de que un día se apague una y las
 * otras sigan anunciando una oferta que ya no existe.
 *
 * ✅ 5-sep-2026: LA WEB YA COBRA 29,99 €. Se creó el precio nuevo en Stripe
 * (price_1UCMTr..., cuenta "Wayo Ai") y se cambió STRIPE_ANNUAL_PRICE_ID en el
 * servidor, así que el checkout web y las tiendas van por fin al mismo precio.
 * El de 49,99 sigue existiendo y NO se borra: el 1-oct se vuelve a él con solo
 * devolver esa variable del .env a `price_1Tki3t...`.
 * ⚠️ Queda una decisión de producto: el botón de la barra sigue mandando a la
 * TIENDA, que era lo correcto cuando la web cobraba de más. Ahora ya podría ir
 * al checkout web.
 */

export const CAMPANA_HASTA = "2026-09-30";

/**
 * Las dos cifras del reclamo: el precio de siempre tachado y el de la campaña.
 *
 * Desde el 5-sep-2026 son también los de la web: el checkout web cobra 29,99 €.
 * La barra sigue diciendo "en la app" y llevando a la tienda, pero ya no es
 * porque la web cobre de más, sino porque no se ha cambiado todavía.
 *
 * ⚠️ Y están en euros. La base de usuarios de la app es LATAM entera, y en Play
 * y App Store cada país ve su moneda convertida: un mexicano no paga 29,99 €.
 * Se asume porque la web se lee en euros y es el mismo par de cifras que ya
 * salió en el push de apertura, pero si algún día se comunica por país, esto es
 * lo primero que hay que tocar.
 */
import { PRECIO_ANUAL, PRECIO_ANTERIOR } from "../config/precios.js";

export const PRECIO_ANTES = PRECIO_ANTERIOR;
export const PRECIO_AHORA = PRECIO_ANUAL;

function hoy() {
  return new Date().toISOString().slice(0, 10);
}

export function campanaVigente() {
  return hoy() <= CAMPANA_HASTA;
}

/**
 * Días que faltan para el cierre, contando el propio día de hoy: el 30 de
 * septiembre devuelve 1 ("queda 1 día"), no 0. Devuelve null si ya pasó.
 */
export function diasQueQuedan() {
  const finaliza = Date.parse(`${CAMPANA_HASTA}T23:59:59Z`);
  const ahora = Date.parse(`${hoy()}T00:00:00Z`);
  if (Number.isNaN(finaliza) || Number.isNaN(ahora) || ahora > finaliza) return null;
  return Math.max(1, Math.ceil((finaliza - ahora) / 86400000));
}

/** "quedan 28 días" / "último día". */
export function cuentaAtras() {
  const dias = diasQueQuedan();
  if (dias === null) return null;
  if (dias === 1) return "último día";
  return `quedan ${dias} días`;
}

/**
 * La misma urgencia en la mitad de sitio. En el móvil, al lado de un reclamo de
 * 20 píxeles, "quedan 28 días" no cabe: se queda en "28 días".
 */
export function cuentaAtrasCorta() {
  const dias = diasQueQuedan();
  if (dias === null) return null;
  if (dias === 1) return "último día";
  return `${dias} días`;
}
